module.exports = __webpack_public_path__ + "fonts/dsiccc2020930.04471de9.eot";